import type { Coords } from '../storelocator/StoreLocatorForm';
import StoreLocatorForm from '../storelocator/StoreLocatorForm';
import * as style from './StoreFacet.module.css';

export interface Props {
    onLocationChange(location: Coords): Promise<void>;
}

export default function StoreFacet({ onLocationChange }: Props) {
    return (
        <div className={style.storeFacet}>
            <StoreLocatorForm
                onLocationChange={onLocationChange}
                onItemSelected={(_id, _name, location) => onLocationChange(location)}
                className={style.storeFinderSearch}
            />
        </div>
    );
}
